<template>
	<tr class="EntryTableEditorRow fields" v-if="!initialLoading && !error">
		<template v-for="control of controlsMerged">
			<!-- TODO: title suffix: locale name, not code -->
			<!-- TODO: gap between langs :style="{ 'padding-top': l > 0 ? '20px' : '' }" -->
			<Field
				v-for="(locale, l) of control.field.localized ? selectedLocaleCodes : [ defaultLocale ]" :key="control.fieldId + '-' + locale"
				style="display: table-cell; min-width: 200px; padding: 5px 10px;"
				v-if="model.fields[control.fieldId] && (!control.field.disabled || showDisabledFields)"
				:style="{ 'padding-top': l > 0 ? '20px' : '' }"
				:entry="model"
				:control="control"
				:field="control.field"
				:titleSuffix="control.field.localized && (selectedLocaleCodes.length > 1 || locale != defaultLocale) ? locale : undefined"
				:locale="locale"
				:localeObject="localeLookup[locale]"
				:disabled="!iCanUpdate"
				v-model="model.fields[control.fieldId][locale]"
				@subedit="forwardSubedit"
				@subeditAsset="forwardSubeditAsset"
				@input="autoSave($event, control, locale)"
				@change="autoSave($event, control, locale)"
				ref="field"
				:tableCell="true"
				class="tableCell"
			/>
		</template>
	</tr>
</template>

<script>
// TODO: update status + publish button per row
// TODO: how to get the list of entry ids to edit?
// TODO: make sure all entries have same type
// TODO: header row
// TODO: allow to make column smaller

import Field from './fields/Field.vue'
import EntryStatus from './fields/EntryStatus.vue'
import { formatDate, userName } from '../utils'
import EntryApiMixin from './EntryApiMixin.js'
import EntryAutoSaveMixin from './EntryAutoSaveMixin'

export default {
	name: 'EntryTableEditorRow',
	components: { Field, EntryStatus },
	mixins: [ EntryApiMixin, EntryAutoSaveMixin ],
	props: {
		entryId: { type: String, required: true },
	},
	data: () => ({
		entryLoader: null,
		initialLoading: true,
		loadingAction: null,
		referencesSelection: [],
		selectedLocaleCodes: [],
		showDisabledFields: false,
		translationItems: [],
		error: null,
		original: null,
		conflicts: null,
		sidebarVisible: false,
		update: 0,
	}),
	computed: {
		contentType() {
			if (!this.model?.sys) return undefined
			const id = this.model.sys.contentType.sys.id
			return this.typeLookup?.[id]
		},
		typeFieldsById() {
			const r = {}
			for (const field of this.contentType?.fields ?? []) {
				r[field.id] = field
			}
			return r
		},
		controlsMerged() {
			const lookup = {} // fieldId -> control
			for (const control of this.editorInterface?.controls ?? [])
				lookup[control.fieldId] = control
			// TODO: we also add the fields defined on the CT
			//       should we mark those somehow, as there are no controls defined for them?
			for (const field of this.contentType.fields) {
				if (!lookup[field.id]) {
					lookup[field.id] = { fieldId: field.id, field, settings: {} }
				}
			}
			return this.contentType.fields.map(field => {
				return { ...lookup[field.id], field }
			})
		},
		localeLookup() {
			const r = {}
			for (const locale of this.locales)
				r[locale.code] = locale
			return r
		},
		iCanUpdate() {
			return this.permissions.iCanUpdate(this.model)
		},
	},
	methods: {
		autoSave(value, control, locale) {
			// TODO: this exploits the effect that selectedLocaleCodes is set at the end of mounted..
			// this prevents that we get change events during startup. this gets rid of MOST init updates.
			/*if (this.selectedLocaleCodes.length == 0) return

			if (control) {
				const field = this.typeFieldsById[control.fieldId]
				const localeCodes = this.locales.map(l => l.code)
				addTranslationItem(this.translationItems, value, field, control, locale, localeCodes, this.original)
			}

			this.entryAutoSave()*/
		},
		formatDate,
		userName,
		forwardSubedit(link, callback) {
			if (link.linkType == 'Asset') {
				this.$emit('subeditAsset', link, callback)
				return
			}
			this.$emit('subedit', link, callback)
		},
		forwardSubeditAsset(link, callback) {
			this.$emit('subeditAsset', link, callback)
		},
	},
	async mounted() {
		await this.loadContentTypes()
		try {
			await this.loadEntry()
		}
		catch (e) {
			console.error('EntryEditor: could not load', this.entryId, e)
			this.error = e.message
			return
		}
		if (!this.contentType) console.error(`Content type ${ this.model.sys.contentType.sys.id } not found!`)
		document.title = this.title
		await this.loadEditorInterface()
		this.initialLoading = false
		this.loadReferences()

		// init autosave mixin
//		this.initAutoSave()

		this.original = JSON.parse(JSON.stringify(this.model))
	},
}
</script>